"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitOfMeasurement = exports.ProductSubType = exports.LicenseType = exports.BillingCycle = exports.PlatformName = exports.ProductVersion = exports.ProductFamily = void 0;
var ProductFamily;
(function (ProductFamily) {
    ProductFamily["V-Ray"] = "VR";
    ProductFamily["Phoenix"] = "PH";
    ProductFamily["VRscans"] = "VS";
    ProductFamily["Pdplayer"] = "PD";
    ProductFamily["Corona"] = "CR";
    ProductFamily["Chaos Cloud"] = "CL";
    ProductFamily["V-Ray Render Node"] = "RN";
    ProductFamily["Beekeeper"] = "BE";
    ProductFamily["Queen Render Node"] = "QN";
    ProductFamily["Fees"] = "FE";
    ProductFamily["Bundle"] = "BD";
    ProductFamily["Enterprise Services"] = "ES";
    ProductFamily["Collections and Suites"] = "CS";
    ProductFamily["Chaos Vantage"] = "CV";
    ProductFamily["ScatterPro"] = "SP";
    ProductFamily["Chaos Player"] = "CP";
    ProductFamily["Corona Render Node"] = "CN";
    ProductFamily["Enscape"] = "EN";
})(ProductFamily = exports.ProductFamily || (exports.ProductFamily = {}));
var ProductVersion;
(function (ProductVersion) {
    ProductVersion["1.0"] = "01";
    ProductVersion["2.0"] = "02";
    ProductVersion["3.0"] = "03";
    ProductVersion["Next/4.0"] = "04";
    ProductVersion["Evergreen"] = "00";
    ProductVersion["Legacy"] = "99";
    ProductVersion["5.0"] = "05";
    ProductVersion["6.0"] = "06";
})(ProductVersion = exports.ProductVersion || (exports.ProductVersion = {}));
var PlatformName;
(function (PlatformName) {
    PlatformName["3ds Max"] = "MX";
    PlatformName["Maya"] = "MA";
    PlatformName["Cinema 4D"] = "CI";
    PlatformName["Modo"] = "MO";
    PlatformName["Nuke"] = "NU";
    PlatformName["Katana"] = "KA";
    PlatformName["FormZ"] = "FZ";
    PlatformName["SketchUp"] = "SK";
    PlatformName["Rhino"] = "RH";
    PlatformName["Revit"] = "RE";
    PlatformName["Unreal"] = "UN";
    PlatformName["Blender"] = "BL";
    PlatformName["Houdini"] = "HO";
    PlatformName["Softimage"] = "SI";
    PlatformName["App SDK"] = "AP";
    PlatformName["Simulation License for Phoenix FD"] = "SL";
    PlatformName["Render Node License for VRScans / V-Ray Standalone / Maintenance / Corona licenses"] = "RN";
    PlatformName["Used only for outdated V-Ray Standalone 2.0 product"] = "ST";
    PlatformName["No platform / universal for all platforms"] = "NO";
    PlatformName["Multiple platforms"] = "MP";
    PlatformName["Solo"] = "SO";
    PlatformName["Premium"] = "PR";
    PlatformName["Enterprise"] = "EN";
    PlatformName["VCP Exam"] = "CP";
    PlatformName["VLT Exam"] = "LT";
    PlatformName["V-Ray Academy"] = "AC";
    PlatformName["ATC Pack / ATC Renewal Pack"] = "AT";
    PlatformName["Renderfarm"] = "RF";
    PlatformName["Royalties"] = "RO";
    PlatformName["Services"] = "SS";
    PlatformName["V-Ray on Demand"] = "OD";
    PlatformName["Maintenance & Support"] = "MS";
    PlatformName["Cloud on Demand"] = "CD";
    PlatformName["Developer Support and Maintenance"] = "DS";
    PlatformName["Dongle"] = "DO";
    PlatformName["Transfer of License Fee"] = "TF";
    PlatformName["License processing fees"] = "LP";
    PlatformName["One-time Contract Fee"] = "OT";
    PlatformName["Additional expenses"] = "AE";
    PlatformName["Shipment expenses"] = "SE";
    PlatformName["Annual Maintenance Fee"] = "MF";
    PlatformName["Consulting services"] = "CS";
    PlatformName["Annual Maintenance Fee services"] = "AF";
})(PlatformName = exports.PlatformName || (exports.PlatformName = {}));
var BillingCycle;
(function (BillingCycle) {
    BillingCycle["Perpetual "] = "PE";
    BillingCycle["Perpetual with maintenance"] = "PM";
    BillingCycle["Annual"] = "AN";
    BillingCycle["Monthly"] = "MO";
    BillingCycle["2 years"] = "A2";
    BillingCycle["3 years"] = "A3";
    BillingCycle["3 months"] = "M3";
    BillingCycle["6 months"] = "M6";
    BillingCycle["Pay-as-you-go metered"] = "PG";
    BillingCycle["Pay-as-you-go pre-paid packages"] = "PP";
    BillingCycle["For a specific period of time - up until a specific date"] = "SP";
    BillingCycle["Weekly"] = "WE";
    BillingCycle["One-time fee/service"] = "OT";
    BillingCycle["45 days duration"] = "FF";
})(BillingCycle = exports.BillingCycle || (exports.BillingCycle = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["Standard"] = "S";
    LicenseType["Evaluation"] = "E";
    LicenseType["Trial"] = "T";
    LicenseType["PrivateBeta"] = "B";
    LicenseType["Dev"] = "D";
    LicenseType["No license provided with product"] = "N";
    LicenseType["Maintenance"] = "M";
    LicenseType["Not for Resale"] = "F";
    LicenseType["License Compliance"] = "C";
    LicenseType["Personal Learning Edition"] = "P";
    LicenseType["Internal use"] = "I";
    LicenseType["Alpha"] = "A";
    LicenseType["PublicBeta"] = "L";
})(LicenseType = exports.LicenseType || (exports.LicenseType = {}));
var ProductSubType;
(function (ProductSubType) {
    ProductSubType["Commercial"] = "C";
    ProductSubType["LegacyStudent"] = "S";
    ProductSubType["University "] = "U";
    ProductSubType["General academic or EDU product "] = "E";
    ProductSubType["Training center / exams / V-Ray Academy fee"] = "T";
    ProductSubType["Additional university license"] = "A";
    ProductSubType["Studio/Trimble"] = "D";
    ProductSubType["Educator"] = "O";
    ProductSubType["Student"] = "N";
})(ProductSubType = exports.ProductSubType || (exports.ProductSubType = {}));
var UnitOfMeasurement;
(function (UnitOfMeasurement) {
    UnitOfMeasurement["License"] = "L";
    UnitOfMeasurement["Render Credit (for Chaos Cloud services)"] = "C";
    UnitOfMeasurement["CPU Thread/Hours usage (for renderfarms/integrations)    "] = "H";
    UnitOfMeasurement["GPU Card/Hours usage (for renderfarms/integrations) "] = "R";
    UnitOfMeasurement["GigaBytes (Storage) (for Chaos Cloud services)"] = "G";
    UnitOfMeasurement["TeraByte (Storage) (for Chaos Cloud services)web."] = "T";
    UnitOfMeasurement["Frames (for Chaos Cloud services)"] = "F";
    UnitOfMeasurement["Megapixels / Pixels (for Chaos Cloud services)"] = "P";
    UnitOfMeasurement["Scene (for Chaos Cloud services)"] = "S";
    UnitOfMeasurement["General units "] = "U";
    UnitOfMeasurement["Corona License + 3 Nodes"] = "A";
    UnitOfMeasurement["Corona License + 5 Nodes"] = "B";
    UnitOfMeasurement["Corona License + 10 Nodes"] = "D";
    UnitOfMeasurement["Corona License + 3 Nodes (new products related to generating link issue)"] = "E";
    UnitOfMeasurement["Fixed"] = "I";
    UnitOfMeasurement["Floating"] = "K";
})(UnitOfMeasurement = exports.UnitOfMeasurement || (exports.UnitOfMeasurement = {}));
//# sourceMappingURL=fields.js.map